import { render, staticRenderFns } from "./ModalStudents.vue?vue&type=template&id=2bfd3bea&"
import script from "./ModalStudents.vue?vue&type=script&lang=ts&"
export * from "./ModalStudents.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudents.vue?vue&type=style&index=0&id=2bfd3bea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports